import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchAllSeries } from '../api/series';
import { fetchCardVariations } from '../api/cardVariation';

// --- Series ---

const seriesFetchAtom = atom(async () => {
    const data = await fetchAllSeries();
    return data;
});

const seriesLoadableAtom = loadable(seriesFetchAtom);
const seriesOverrideAtom = atom(null);

// Self-loading, writable. Returns [] while loading.
export const seriesAtom = atom(
    (get) => {
        const override = get(seriesOverrideAtom);
        if (override !== null) return override;
        const fetched = get(seriesLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data : [];
    },
    (get, set, update) => {
        const override = get(seriesOverrideAtom);
        let current;
        if (override !== null) {
            current = override;
        } else {
            const fetched = get(seriesLoadableAtom);
            current = fetched.state === 'hasData' ? fetched.data : [];
        }
        set(seriesOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);

// --- Variations ---

const variationsFetchAtom = atom(async () => {
    const data = await fetchCardVariations();
    return data;
});

const variationsLoadableAtom = loadable(variationsFetchAtom);
const variationsOverrideAtom = atom(null);

// Self-loading, writable. Returns [] while loading.
export const variationsAtom = atom(
    (get) => {
        const override = get(variationsOverrideAtom);
        if (override !== null) return override;
        const fetched = get(variationsLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data : [];
    },
    (get, set, update) => {
        const override = get(variationsOverrideAtom);
        let current;
        if (override !== null) {
            current = override;
        } else {
            const fetched = get(variationsLoadableAtom);
            current = fetched.state === 'hasData' ? fetched.data : [];
        }
        set(variationsOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);
